'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPublicGlobalBranding = fetchPublicGlobalBranding;

var _endpoints = require('MeetingsLib/constants/endpoints');

function fetchPublicGlobalBranding(httpClient, portalId, userId) {
  return httpClient.get(_endpoints.BRANDING_ENDPOINT + '/public-branding?portalId=' + portalId + '&userId=' + userId, {
    withCredentials: false
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/api/publicGlobalBrandingAPI.js
// module id = 323
// module chunks = 0